import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const listTyresApi = (query = {}) =>
  f3tch('/tyres')
    .profile(profile({url: API_URL()}))
    .query(query)
    .get();

export default listTyresApi;
